import { render, staticRenderFns } from "./L3PermissionEnable.vue?vue&type=template&id=80408d94"
import script from "./L3PermissionEnable.vue?vue&type=script&lang=js"
export * from "./L3PermissionEnable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports